
const MootCompetitionStudentDetails = ({ data }) => {
  return (
    <div className="student-details-wrapper" style={{ background: '#fff', borderRadius: '16px', padding: '2rem', margin: '4rem 0 2rem 0', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', maxHeight: '87vh', overflowY: 'auto', fontFamily: 'Inter' }}>
      <h2 style={{ marginBottom: '1.5rem', color: '#663399',fontFamily: 'Inter' }}>Registration Details</h2>
      {data && data._id ? (
        <div className="student-details-content" style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 45%', minWidth: 260, background: '#f6f6fa', borderRadius: 12, padding: 16 }}>
              <h4 style={{ color: '#663399', marginBottom: 8 }}>Institution</h4>
              <p><strong>Name:</strong> {data.institutionName}</p>
              <p><strong>Address:</strong> {data.institutionAddress}</p>
            </div>
            <div style={{ flex: '1 1 45%', minWidth: 260, background: '#f6f6fa', borderRadius: 12, padding: 16 }}>
              <h4 style={{ color: '#663399', marginBottom: 8 }}>Payment</h4>
              <p><strong>Amount:</strong> {data.amount}</p>
              <p><strong>Payment Status:</strong> {data.paymentStatus}</p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 45%', minWidth: 260, background: '#f6f6fa', borderRadius: 12, padding: 16 }}>
              <h4 style={{ color: '#663399', marginBottom: 8 }}>Speaker 1</h4>
              <p><strong>Name:</strong> {data.speaker1Name}</p>
              <p><strong>Email:</strong> {data.speaker1Email}</p>
              <p><strong>Phone:</strong> {data.speaker1Phone}</p>
              <p><strong>Course:</strong> {data.speaker1Course}</p>
              <p><strong>Year:</strong> {data.speaker1Year}</p>
            </div>
            <div style={{ flex: '1 1 45%', minWidth: 260, background: '#f6f6fa', borderRadius: 12, padding: 16 }}>
              <h4 style={{ color: '#663399', marginBottom: 8 }}>Speaker 2</h4>
              <p><strong>Name:</strong> {data.speaker2Name}</p>
              <p><strong>Email:</strong> {data.speaker2Email}</p>
              <p><strong>Phone:</strong> {data.speaker2Phone}</p>
              <p><strong>Course:</strong> {data.speaker2Course}</p>
              <p><strong>Year:</strong> {data.speaker2Year}</p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 45%', minWidth: 260, background: '#f6f6fa', borderRadius: 12, padding: 16 }}>
              <h4 style={{ color: '#663399', marginBottom: 8 }}>Researcher</h4>
              <p><strong>Name:</strong> {data.researcherName}</p>
              <p><strong>Email:</strong> {data.researcherEmail}</p>
              <p><strong>Phone:</strong> {data.researcherPhone}</p>
              <p><strong>Course:</strong> {data.researcherCourse}</p>
              <p><strong>Year:</strong> {data.researcherYear}</p>
            </div>
            <div style={{ flex: '1 1 45%', minWidth: 260, background: '#f6f6fa', borderRadius: 12, padding: 16 }}>
              <h4 style={{ color: '#663399', marginBottom: 8 }}>Faculty</h4>
              <p><strong>Name:</strong> {data.facultyName}</p>
              <p><strong>Designation:</strong> {data.facultyDesignation}</p>
              <p><strong>Email:</strong> {data.facultyEmail}</p>
              <p><strong>Phone:</strong> {data.facultyPhone}</p>
            </div>
          </div>
        </div>
      ) : (
        <p>No student data available.</p>
      )}
    </div>
  );
};

export default MootCompetitionStudentDetails; 